import pxToRem from "../../functions/pxToRem";

export default function contained({ colors, typography }) {
  const { background, text, info, secondary } = colors;
  const { size } = typography;

  const contained = {
    base: {
      backgroundColor: background.paper,
      minHeight: pxToRem(40),
      color: text.main,
      padding: `${pxToRem(10)} ${pxToRem(24)}`,

      "&:hover": {
        backgroundColor: background.paper,
      },

      "&:active, &:active:focus, &:active:hover": {
        opacity: 0.85,
      },

      "& .material-icon, .material-icons-round, svg": {
        fontSize: `${pxToRem(16)} !important`,
      },
    },

    small: {
      minHeight: pxToRem(32),
      padding: `${pxToRem(6)} ${pxToRem(16)}`,
      fontSize: size.xs,

      "& .material-icon, .material-icons-round, svg": {
        fontSize: `${pxToRem(12)} !important`,
      },
    },

    large: {
      minHeight: pxToRem(47),
      padding: `${pxToRem(12)} ${pxToRem(28)}`,
      fontSize: size.sm,

      "& .material-icon, .material-icons-round, svg": {
        fontSize: `${pxToRem(22)} !important`,
      },
    },

    primary: {
      backgroundColor: info.main,

      "&:hover": {
        backgroundColor: info.main,
      },

      "&:focus:not(:hover)": {
        backgroundColor: info.focus,
      },
    },

    secondary: {
      backgroundColor: secondary.main,

      "&:hover": {
        backgroundColor: secondary.main,
      },

      "&:focus:not(:hover)": {
        backgroundColor: secondary.focus,
      },
    },
  };

  return contained;
}
